// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__n_oss","unitsBtn":"switch_unitsBtn__Qdsjy","unitsBtnSelected":"switch_unitsBtnSelected__Ngv3M"};